import Svg, { Path } from 'react-native-svg';
import { type MinimalSvgProps, withDefaultIconProps } from './index';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

type InsuredBadgeProps = MinimalSvgProps & { checkColor?: string };

export const InsuredBadge = withDefaultIconProps<InsuredBadgeProps>(
  { height: 36, width: 36, color: theme.colors['surface.tertiary'] },
  ({ checkColor = '#2B8176', color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 36 36">
      <Path
        d="M15.49 2.45C16.88 1.09 19.11 1.09 20.51 2.45L22.28 4.17C22.94 4.82 23.83 5.18 24.75 5.2L27.22 5.23C29.17 5.25 30.75 6.83 30.77 8.78L30.8 11.25C30.82 12.17 31.18 13.06 31.83 13.72L33.55 15.49C34.91 16.88 34.91 19.11 33.55 20.51L31.83 22.28C31.18 22.94 30.82 23.83 30.8 24.75L30.77 27.22C30.75 29.17 29.17 30.75 27.22 30.77L24.75 30.8C23.83 30.82 22.94 31.18 22.28 31.83L20.51 33.55C19.11 34.91 16.88 34.91 15.49 33.55L13.72 31.83C13.06 31.18 12.17 30.82 11.25 30.8L8.78 30.77C6.83 30.75 5.25 29.17 5.23 27.22L5.2 24.75C5.18 23.83 4.82 22.94 4.17 22.28L2.45 20.51C1.09 19.11 1.09 16.88 2.45 15.49L4.17 13.72C4.82 13.06 5.18 12.17 5.2 11.25L5.23 8.78C5.25 6.83 6.83 5.25 8.78 5.23L11.25 5.2C12.17 5.18 13.06 4.82 13.72 4.17L15.49 2.45Z"
        fill={color}
      />
      <Path
        clipRule="evenodd"
        d="M26.04 12.69C26.75 13.38 26.76 14.52 26.07 15.24L16.61 24.96L11.49 19.7C10.8 18.98 10.81 17.84 11.53 17.15C12.24 16.46 13.38 16.47 14.07 17.19L16.61 19.8L23.49 12.73C24.18 12.01 25.32 12 26.04 12.69Z"
        fill={checkColor}
        fillRule="evenodd"
      />
    </Svg>
  ),
);
